export function renderNumberFieldJsxFieldControllerTemplate({
  name,
  fieldContainerClass,
  formLabelWithDescriptionLine,
  escapeAttribute,
  inputClass,
  errorMessageLine
}: {
  name: string
  fieldContainerClass: string
  formLabelWithDescriptionLine: string
  escapeAttribute: string
  inputClass: string
  errorMessageLine: string
}): string {
  return `        <Controller
          control={form.control}
          name="${name}"
          render={({ field }) => (
            <div className="${fieldContainerClass}">
              ${formLabelWithDescriptionLine}
              <input
                id="${name}"
                type="number"
                placeholder="${escapeAttribute}"
                value={field.value ?? ''}
                onChange={(event) => {
                  const nextValue = event.target.value === '' ? undefined : event.target.valueAsNumber
                  const normalizedValue = Number.isNaN(nextValue) ? undefined : nextValue
                  field.onChange(normalizedValue)
                }}
                onBlur={field.onBlur}
                name={field.name}
                ref={field.ref}
                className="${inputClass}"
              />
${errorMessageLine}
            </div>
          )}
        />`
}
